import * as React from 'react';
import { useSelector } from 'react-redux';
import { IType, IFlightType } from './type';
import { AnimatedContainer } from '../../components/AnimatedContainer';
import { Advantages, Advantage } from '../../components/LandingPageV2/Advantages';
import { selectFlightEnabled } from '../../selectors/meta/selectFlightEnabled';
import { selectIsAnimationAvailable } from '../../selectors/pageState';

const DEFAULT_CONTENT: { title: string; description: string; type: IType }[] = [
  {
    title: 'Сэкономим ваше\u00A0время',
    description: `Отсмотрим тысячи объявлений\u00A0за\u00A0вас`,
    type: 'time',
  },
  {
    title: 'Знаем надёжных застройщиков',
    description: `Проверяем сроки сдачи, документы, фото со\u00A0стройки`,
    type: 'reliability',
  },
  {
    title: 'Учтём любые пожелания',
    description: 'Бюджет, район, планировку\u00A0— всё, что\u00A0вам\u00A0важно',
    type: 'wishes',
  },
  { title: 'И\u00A0всё\u00A0это\u00A0— бесплатно', description: '', type: 'price' },
];

const FLIGHT_CONTENT: { title: string; description: string; type: IFlightType }[] = [
  {
    title: 'Поможем на\u00A0любом\u00A0этапе',
    description: 'Только подобрать варианты или\u00A0сопроводить до\u00A0покупки — работаем, как вам удобнее',
    type: 'support',
  },
  {
    title: 'Знаем всё о\u00A0рынке и\u00A0застройщиках ',
    description: '',
    type: 'expertise',
  },
  {
    title: 'Учтём всё\u00A0— бюджет, район, планировку',
    description: '',
    type: 'personalization',
  },
  { title: 'Юридические тонкости\u00A0— на\u00A0нас', description: '', type: 'legal' },
];

export const AdvantagesContainer = (): React.JSX.Element => {
  const isAnimationAvailable = useSelector(selectIsAnimationAvailable);
  const flightEnabled = useSelector(selectFlightEnabled);
  const content = flightEnabled ? FLIGHT_CONTENT : DEFAULT_CONTENT;

  return (
    <Advantages>
      {content.map(item => (
        <AnimatedContainer key={item.title} isAnimationAvailable={isAnimationAvailable}>
          <Advantage key={item.title} {...item} flightEnabled={flightEnabled} />
        </AnimatedContainer>
      ))}
    </Advantages>
  );
};
